import { render, staticRenderFns } from "./WineryList.vue?vue&type=template&id=514c2909&scoped=true&"
import script from "./WineryList.vue?vue&type=script&lang=ts&"
export * from "./WineryList.vue?vue&type=script&lang=ts&"
import style0 from "./WineryList.vue?vue&type=style&index=0&id=514c2909&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514c2909",
  null
  
)

export default component.exports